import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createEmploymentInfo,
  updateEmploymentInfo,
} from '../store/actions/employmentStatus/employmentStatusActions';
import useApplicationUid from './useApplicationUid';

const useEmploymentInfoDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const employmentInfoDispatch = ({
    data,
    defaultValues,
    onSuccess,
    onError,
  }) => {
    const shouldSkip = isEqual(data, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      data,
      onSuccess,
      onError,
    };

    if (defaultValues?.EmploymentStatus && !isEqual(data, defaultValues)) {
      dispatch(
        updateEmploymentInfo({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createEmploymentInfo({
        ...requestData,
      }),
    );
  };

  return { employmentInfoDispatch };
};

export default useEmploymentInfoDispatch;
